const LicenseTypes = [
    { field: 'TC', name: 'Teacher Certification' },
    { field: 'AL', name: 'Admin License' },
    { field: 'TP', name: 'Technical Permit' },
    { field: 'AN', name: 'Ancillary' }
]
    
export { LicenseTypes }